import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import type { ComponentProps } from "react";
import { RouterProvider } from "react-router";
import { EnvironmentProvider, type AppEnvironment } from "../shared/environment.tsx";
import { InstallProvider } from "../shared/install/InstallProvider.tsx";
import { SessionProvider } from "../shared/session/SessionProvider.tsx";

type AppProps = {
  environment: AppEnvironment;
  router: ComponentProps<typeof RouterProvider>["router"];
  queryClient: QueryClient;
};

/** Корень приложения: браузерный (main.tsx) и тестовый (renderApp) отличаются только аргументами. */
export function App({ environment, router, queryClient }: AppProps) {
  return (
    <EnvironmentProvider environment={environment}>
      <QueryClientProvider client={queryClient}>
        <SessionProvider>
          <InstallProvider>
            <RouterProvider router={router} />
          </InstallProvider>
        </SessionProvider>
      </QueryClientProvider>
    </EnvironmentProvider>
  );
}
